import type { DriveStep } from 'driver.js';

export const doctorBillingSteps: DriveStep[] = [
  {
    // Balance cards are always rendered (unconditionally), making this a
    // reliable first step for auto-start. The Stripe Connect card is
    // conditionally rendered only when not connected, so placing it first
    // would prevent the tour from ever starting for connected users.
    element: '[data-tour="doctor-billing-balance"]',
    popover: {
      title: 'Your Balance',
      description:
        "Available and pending balances. Funds move to available on Stripe's payout schedule.",
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-billing-stripe"]',
    popover: {
      title: 'Stripe Connect',
      description:
        'Connect your Stripe account to receive payments and access your Stripe dashboard.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-billing-payouts"]',
    popover: {
      title: 'Payout History',
      description: 'All completed payouts to your bank account with dates and amounts.',
      side: 'top',
      align: 'center',
    },
  },
];
